import React from 'react'
import Header from '../../components/Header/Header.jsx'
import './about.css'
import SocialIconsContainer from '../../components/Container/SocialIconsContainer.jsx'

import DisclaimerPopup from '../../components/Popups/DisclaimerPopup.jsx'
function About() {
  const [Active,setActive]=React.useState(false)
  return (
    <div className='body'>
      <Header/>
      <div className='about'>
    <p>About</p>
    <div className='card'>
      <div className='about-info'>
        <img src='/assets/Info.png'  onClick={()=>setActive(true)}/>
      </div>
      <div className='content'>
       
      <p>
      BuxSwap has been designed to facilitate seemless conversions between on-chain and off-chain tokens. As the prevalence of off-chain tokens within the defi space grows, this has become more and more important. 
<br/><br/>
The platform, at present, offers a conversion service between GoldBux (on-chain token) and EggBux (off-chain token). This process works in a similar way to an AMM (automated market-maker) exchange. To use the platform, first connect your Ethereum wallet - you will then be able to check your balances. To make a conversion, you will have to first ‘deposit’ some of your GoldBux, which will credit your wallet with “off-chain GoldBux” - this will cost a small gas fee. You can then select the amount you’d like to convert and confirm the transaction, which will be gas-free as all the conversions will happen off-chain. If you would like to convert EggBux for GoldBux, you will first carry out the conversion, then ‘claim’ your resulting off-chain GoldBux, which will then credit your wallet with on-chain GoldBux tokens - again, this would cost a small gas fee.
<br/><br/>  
If you are keen to learn more about BuxSwap, or your project has an on-chain/ off-chain token you would like to list here, then get in touch via the discord link below.
      </p>
      </div>

    </div>
  </div>
  <SocialIconsContainer/>
  {Active && 
   <DisclaimerPopup onClose={()=>setActive(false)}/>
  }
 
  </div>
  )
}

export default About